/**
 * Copilot caption → custom-widget mapping, injected into the graphic's
 * `v_ui["x-captionWidgets"]` so Maestro renders these widgets in place of the
 * default caption inputs. Widget keys must match TXLive's `customInputWidgets`.
 * `x-widget-config` becomes the widget's `widgetConfig` prop.
 */
export function buildCopilotCaptionWidgets({
  homeAccent,
  rendererUrl,
  clockConstraints,
} = {}) {
  return {
    // NOTE: no Substitution entry — copilot deliberately falls through to
    // the default caption-inputs form (the jsonata-populated "Select
    // Substitution Group" + player On/Off dropdowns), same as drive. Do not
    // map a substitution widget here.
    AdditionalTime: {
      "x-widget": "additionalTimePanel",
      "x-widget-config": {},
    },
    ClockOverwrite: {
      "x-widget": "CopilotClockOverwriteWidget",
      "x-widget-config": {
        minMinutes: clockConstraints?.min,
        maxMinutes: clockConstraints?.max,
        accent: homeAccent,
      },
    },
    ClockReset: {
      "x-widget": "CopilotClockResetWidget",
      "x-widget-config": { dangerAccent: "#d10d0d" },
    },
  };
}
